import { boolean, object, SchemaOf } from "yup";
import { sanitizeFileName } from "@epcnetwork/core-ui-kit";

import { emailColumnValidation, headersValidation } from "utils";
import { requiredFieldText } from "constants/form.constants";
import { csvFormat, txtFormat } from "constants/file.constants";
import { IspSplitterFileData, IspSplitterValues } from "./isp-splitter.types";

export const supportedFormats = [csvFormat, txtFormat].flat();

export const getInitialData = (item: File): IspSplitterFileData => ({
  fileName: sanitizeFileName(item.name),
  headers: [],
  hasHeaders: false,
  emailIndex: -1,
  suppress: true,
});

export const validationSchema: SchemaOf<IspSplitterValues> = object({
  fileValues: object({
    emailIndex: emailColumnValidation(),
    headers: headersValidation(),
    hasHeaders: boolean().required(requiredFieldText),
    suppress: boolean(),
  }).required(requiredFieldText),
});
